import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'apartment';

export const apartmentTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const withoutApartments = getTermValue('only_flat')(jsonQuery);
    const onlyApartments = getTermValue('apartment')(jsonQuery);

    if (!withoutApartments && !onlyApartments) {
      return null;
    }

    if (withoutApartments && !onlyApartments) {
      return [{ label: 'Без апартаментов', value: createTagValue(ID) }];
    }

    return [{ label: 'Только апартаменты', value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['only_flat', 'apartment'])(jsonQuery),
};
